var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-3 w-100 d-flex flex-column flex-md-row align-items-center justify-content-center"},[_c('h6',{staticClass:"m-0 p-0 font-weight-bold"},[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")]),_vm._v(" "),_vm._t("complement")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }